// extracted by mini-css-extract-plugin
export default {"container":"AnalyticsPageLayout_container__wOGQ+","header":"AnalyticsPageLayout_header__45aDU","title":"AnalyticsPageLayout_title__6kFWM"};